import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faExclamation,
  faListAlt,
  faUser,
  faList,
  faArrowCircleRight,
  faComments,
  faNewspaper,
  faEuro,
  faBuilding,
  faTasks,
  faBriefcase,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";
import HazardManagement from "./HazardManagement";
import Header from "../Header/Header";
import { useMediaQuery } from "react-responsive";
import RiskSubCategories from "./RiskSubCategories";
import RiskCategoriesType from "./RiskCategoriesType";
import CompanyType from "./CompanyType";
import Companies from "./Companies";
import Users from "./Users";
import RiskSolutions from "./RiskSolutions";
import Plans from "./Plans";
import SubscriptionList from "./SubscriptionList";
import "./Admin.css";
import DashboardCard from "./DashboardCard";

const Dashboard = () => {
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const [onTop, setOnTop] = useState(true);
  const [activeTab, setActiveTab] = useState("first");

  const handleScrollToTable = () => {
    const tableElement = document.getElementById("table");
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  function scrollFunction() {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      setOnTop(false);
    } else {
      setOnTop(true);
    }
  }

  useEffect(() => {
    window.onscroll = function () {
      scrollFunction();
    };
  }, []);

  const [selectedCard, setSelectedCard] = useState(null);

  const handleCardClick = (index) => {
    setSelectedCard(index);
  };

  const renderActiveTab = () => {
    switch (selectedCard) {
      case 0:
        return <Companies scrollToTable={handleScrollToTable} />;
      case 1:
        return <CompanyType />;
      case 2:
        return <SubscriptionList />;
      case 3:
        return <Users />;
      case 4:
        return <HazardManagement />;
      case 5:
        return <RiskSubCategories />;
      case 6:
        return <RiskCategoriesType />;
      case 7:
        return <RiskSolutions />;
      case 8:
        return <Plans />;
      default:
        return null;
    }
  };

  return (
    <>
      {onTop ? (
        <Header requiredHeight={170} logout={true} />
      ) : (
        <Header requiredHeight={60} logout={true} />
      )}
      {/* <div className={isPortrait ? "container-fluid" : "container"}>
        <div className="navbar">
          <div className="nav-link" onClick={() => setActiveTab("first")}>
            <FontAwesomeIcon icon={faExclamationTriangle} /> Gefährdung
          </div>
          <div className="nav-link" onClick={() => setActiveTab("second")}>
            <FontAwesomeIcon icon={faListAlt} /> Kategorien
          </div>
        </div>
        <div className="tab-content">
          {activeTab === "first" && <HazardManagement />}
          {activeTab === "second" && (
            <div>
              <RiskSubCategories />
              <RiskCategoriesType />
              <CompanyType />
            </div>
          )}
        </div>
      </div> */}
      <div className="container-fluid">
        <div className="row">
          <DashboardCard
            icon={faBuilding}
            color="#332885"
            count="10"
            label="Companies"
            isSelected={selectedCard === 0}
            onClick={() => handleCardClick(0)}
          />
          <DashboardCard
            icon={faBriefcase}
            color="#332885"
            count="10"
            label="Company Types"
            isSelected={selectedCard === 1}
            onClick={() => handleCardClick(1)}
          />
          <DashboardCard
            icon={faEuro}
            color="#332885"
            count="10"
            label="Payments"
            isSelected={selectedCard === 2}
            onClick={() => handleCardClick(2)}
          />
          <DashboardCard
            icon={faUser}
            color="#332885"
            count="10"
            label="Users"
            isSelected={selectedCard === 3}
            onClick={() => handleCardClick(3)}
          />
          <DashboardCard
            icon={faExclamationTriangle}
            color="#332885"
            count="10"
            label="Risk Categories"
            isSelected={selectedCard === 4}
            onClick={() => handleCardClick(4)}
          />
          <DashboardCard
            icon={faExclamation}
            color="#332885"
            count="10"
            label="Risk Sub Categories"
            isSelected={selectedCard === 5}
            onClick={() => handleCardClick(5)}
          />
          <DashboardCard
            icon={faListAlt}
            color="#332885"
            count="10"
            label="Risk Sub Category Types"
            isSelected={selectedCard === 6}
            onClick={() => handleCardClick(6)}
          />
          <DashboardCard
            icon={faTasks}
            color="#332885"
            count="10"
            label="Risk Solutions"
            isSelected={selectedCard === 7}
            onClick={() => handleCardClick(7)}
          />
          <DashboardCard
            icon={faRocket}
            color="#332885"
            count="10"
            label="Subscription Plans"
            isSelected={selectedCard === 8}
            onClick={() => handleCardClick(8)}
          />
        </div>
        <div className="tab-content">{renderActiveTab()}</div>
      </div>
    </>
  );
};

export default Dashboard;
